var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notifications-feed"},_vm._l((_vm.notifications),function(notification,index){return _c('NotificationCard',{key:index,attrs:{"notification":notification},on:{"link-click":_vm.handleLinkClick}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }